import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Action from '../actions';
import {connect} from 'react-redux';

class DownloadCheckedLineups extends Component {
    onClick() {
        this.props.dispatch(Action.do('downloadCheckedLineups'));
    }

    render() {
        const {className = '', children = null} = this.props;

        return (
            <button type="button" className={className} onClick={::this.onClick}>
                {children}
            </button>
        );
    }
}

export default connect(() => ({}))(DownloadCheckedLineups);
